// 秒 → 人看的时间 —— **一份定义,前后端共用**。
//
// 收口之前有 8 份,而且**互相矛盾**:
//   · Storyboard.tsx 一个文件里就有两份(round / floor)→ 59.6 秒那张卡在墙上写 `1:00`、
//     底下的总时长写 `0:59`。同一堵墙,两个真相。
//   · ProjectLibrary / Templates / TemplateDetail 那三份用 `Math.round(s % 60)` ——
//     **59.6 秒会印成 `0:60`**。取整之后再取模,进位丢了。
//
// 口径钉死:**向下取整**(和视频播放器一致 —— 59.6 秒时播放器显示 0:59,不是 1:00),
// 而且**先取整、再拆分钟秒**,进位不会丢。

/** `0:00` —— 播放头、时长、时间轴刻度。 */
export const mmss = (s: number): string => {
  const t = Math.max(0, Math.floor(+s || 0));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
};

/** `45s` / `2:03` —— 列表里的时长标签(不足一分钟时说"多少秒"更好读)。
 *  亚秒素材(短音效 0.29s)不能 floor 吞成 0 —— 那是它唯一的时长信息,保留一位小数。 */
export const durLabel = (s?: number): string | null => {
  const raw = Math.max(0, Number(s) || 0);
  if (!raw) return null;
  const t = Math.floor(raw);
  if (!t) return `${Math.round(raw * 10) / 10}s`;
  return t < 60 ? `${t}s` : mmss(t);
};
